import {
  Component,
  computed,
  ElementRef,
  inject,
  input,
  output,
  viewChildren
} from '@angular/core';
import { SpecialWizardService } from '../../services/special-wizard.service';
import { IconNameType } from '../../../shared/icons/icon-name-type.enum';
import { IconComponent } from '../../../shared/icons/icon.component';
import { CommonModule } from '@angular/common';
import { SpecialWizard } from '../../models/core/special-wizard';
import { DottedLabelsComponent } from '../../../shared/dotted-labels/dotted-labels.component';
import { TranslocoDirective } from '@ngneat/transloco';

@Component({
  selector: 'cwo-special-item-editor-steps',
  standalone: true,
  imports: [IconComponent, CommonModule, DottedLabelsComponent, TranslocoDirective],
  templateUrl: './special-item-editor-steps.component.html',
  styleUrl: './special-item-editor-steps.component.scss',
})
export class SpecialItemEditorStepsComponent {
  specialWizardService = inject(SpecialWizardService);
  specialWizard = input.required<SpecialWizard | null>();
  highlightInvalidFields = input(false);
  iconNameType = IconNameType;

  steps = computed(() => {
    return this.specialWizardService.editingSpecialWizard()?.steps ?? [];
  });

  readonly showStepItemList = output<number>();
  readonly editStepItem = output<number>();

  readonly stepElements = viewChildren<ElementRef>('stepRef');

  focusStep(index: number) {
    const stepElement = this.stepElements()?.at(index);
    if (stepElement) {
      stepElement.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }
  handleShuffle(index: number) {
    this.showStepItemList.emit(index);
  }
}
